import { useEffect } from 'react'
import { siteConfig } from '@/config/site'
import { initGoogleTags } from '@/lib/google-tags'

/** Injects GTM on mount when set. GA4 loads from built `index.html` (see `vite.config.ts`). */
export const GoogleTagsInit = () => {
  useEffect(() => {
    initGoogleTags({
      gtmContainerId: siteConfig.gtmContainerId,
      gaMeasurementId: siteConfig.gaMeasurementId,
    })
  }, [])

  return null
}
